import OrderFinancialBreakdown from 'src/components/shared/OrderFinancialBreakdown'
import { PrinterOutlined } from '@ant-design/icons'
import { PDFExport } from '@progress/kendo-react-pdf'
import { Button, Menu, Modal, Popconfirm, Tooltip } from 'antd'
import Dinero from 'dinero.js'
import 'jspdf-autotable'
import moment from 'moment'
import React, { Fragment, useEffect, useRef, useState } from 'react'
import { CSVLink } from 'react-csv'
import { buildCsvString } from 'src/utils/csv'
import { getOrderedQuantity, getQuantity } from 'src/utils/priceFunctions'
import { useDispatch, useSelector } from 'react-redux'
import { Link, Redirect, useHistory, useLocation } from 'react-router-dom'
import Logo from 'src/assets/images/OMSLogoBlk.png'
import OMSErrorBoundary from 'src/components/shared/ErrorBoundary'
import {
  FoodSafetyHeaderRow,
  FoodSafetyHeroBand,
  FoodSafetyPageTitle,
} from 'src/components/food-safety/FoodSafetyPageChrome'
import OllieContextualAsk from 'src/components/ollie/OllieContextualAsk'
import OllieNoticedRows from 'src/components/ollie/OllieNoticedRows'
import { OLLIE_CONTEXTUAL_ASK_FALLBACKS } from 'src/utils/ollieContextualAsk'
import { OLLIE_NOTICED_PAGES } from 'src/utils/ollieNoticedRows'
import getSubtitle from 'src/components/shared/header-screen/getSubtitle'
import getTitle from 'src/components/shared/header-screen/getTitle'
import ThreeWayMatchEducation from 'src/components/shared/ThreeWayMatchEducation'
import VatToggle from 'src/components/shared/VatToggle'
import NoDataScreen from 'src/components/shared/no-data-screen/NoDataScreen'
import FadeIn from 'src/components/styled/FadeIn'
import Loading from 'src/components/styled/Loading'
import Filter from 'src/screens/orders/Filter'
import styled from 'styled-components'
import _ from 'underscore'
import { postPhoneOrders } from '../../features/AddPhoneOrders'
import { fetchOrders } from '../../features/OrdersSlice'
// import { fetchVenueProducts } from '../../features/VenueProductsSlice'
import { getVenueSuppliers } from '../../features/VenueSuppliersSlice'
// import { fetchManualSuppliersProducts } from '../../features/ManualSuppliersProductsSlice'
import { persistManualOrderWholeOrderDiscount } from 'src/utils/persistManualOrderDiscount'
import AddInvoiceModal from './add-invoice-modal/AddInvoiceModal'
import { updateFeatureLimit } from 'src/features/SubscriptionSlice'
import TooMuchData from './TooMuchData'
import { API } from 'src/utils/interceptor'
import { rematchInvoiceMatching } from 'src/features/NewInvoicesSlice'
import {
  RejectedNotification,
  SuccessNotification,
} from 'src/notifications/SuccessNotification'
import {
  ReceiptingHealthTabLabel,
  InvoiceMatchingWorkTabLabel,
  CreditRequestHealthTabLabel,
  formatPurchasingNavA11yName,
  buildReceiptingHealthTooltip,
  buildInvoiceMatchingWorkTooltip,
  buildInvoicesPath,
  fetchReconciliationHealthSummary,
  fetchOpenCreditRequestCount,
} from 'src/utils/reconciliationHealthApi'
import { buildCreditRequestHealthTooltip } from 'src/utils/askForCreditBridgeHelpers'
import { CN_DOCUMENT_COPY } from 'src/utils/creditNoteDocumentHelpers'
import useUserRole from 'src/hooks/useUserRole'
import { useVenueCustomRoles } from 'src/hooks/useIsBlocked'
import {
  canAccess,
  getDashboardPurchasingHomePath,
} from 'src/utils/permissions'
import { PURCHASING_NAV_TOOLTIP_PROPS } from 'src/utils/purchasingChrome'

const OLLIE_NOTICED_SLUGS = {
  orders: OLLIE_NOTICED_PAGES.ORDERS,
  receipting: OLLIE_NOTICED_PAGES.RECEIPTING,
  invoices: OLLIE_NOTICED_PAGES.INVOICES,
}

const { Item } = Menu

const Orders = ({ children }) => {
  const error = useSelector(state => state.orders.error)
  const [orderToInvoice, setOrderToInvoice] = useState({})
  const [pendingRematchInvoiceId, setPendingRematchInvoiceId] = useState(null)
  const [initialManualOrderPo, setInitialManualOrderPo] = useState('')
  const [manualOrderDiscountPounds, setManualOrderDiscountPounds] = useState(0)
  const dispatch = useDispatch()
  const location = useLocation()
  const history = useHistory()
  const orderedProduct = useSelector(state => state.orders.orderedProduct)
  const [change, setChange] = useState('none')
  const [modalShow, setModalShow] = useState(false)
  const [addInvoiceLoading, setAddInvoiceLoading] = useState(false)
  const [isInvalidOrder, setIsInvalidOrder] = useState(false)
  const orderProductsGroupedByTypes = _(orderedProduct).groupBy(
    item => item.type,
  )
  const allOrdersProductsGroupedByType = orderProductsGroupedByTypes
  // const isCreditApproved = useSelector(
  //   state => state.auth.account.creditApproved,
  // )
  const isLoading = useSelector(state => state.orders.isLoading)
  const orders = useSelector(state => state.orders.filtered)
  const venue = useSelector(state => state.venue.venue)
  const { _id: venueId, title } = venue || {}
  const venueSupplier = useSelector(
    state => state.venueSuppliers.venueSuppliers,
  )
  // Removed unused selectors - products are now loaded on-demand via Redux
  const orderProductsGroupedByType = _(orderedProduct).groupBy(
    // changed from type to supplier name to alter the CSV of ordered products
    item => item.supplierName,
  )
  const { currentPlan } =
    useSelector(state => state.venue?.venue?.usageLimits) ?? ''
  const userRole = useUserRole()
  const customRoles = useVenueCustomRoles()
  const canSeePurchasingNav = screen => canAccess(screen, userRole, customRoles)
  const [receiptingHealth, setReceiptingHealth] = useState({
    needsAction: 0,
    matchingWorkCount: 0,
    openCreditRequestCount: 0,
    dateRangeLabel: null,
  })

  // Removed mergedProducts logic - products are now loaded on-demand via Redux

  // Removed useEffect for manualSuppliersProducts since we're not using it anymore

  useEffect(() => {
    dispatch(getVenueSuppliers(venueId))
    // Remove pre-loading of all products - now loaded on demand when supplier is selected
    // dispatch(fetchVenueProducts(venueId))
    // dispatch(fetchManualSuppliersProducts(venueId))
  }, [])

  useEffect(() => {
    if (!venueId) return undefined

    let cancelled = false

    Promise.all([
      fetchReconciliationHealthSummary({
        venueId,
        apiGet: API.get,
      }),
      fetchOpenCreditRequestCount({
        venueId,
        apiGet: API.get,
      }),
    ])
      .then(([summary, openCreditRequestCount]) => {
        if (!cancelled) {
          setReceiptingHealth({
            ...summary,
            openCreditRequestCount,
          })
        }
        return null
      })
      .catch(() => {
        if (!cancelled) {
          setReceiptingHealth({
            needsAction: 0,
            matchingWorkCount: 0,
            openCreditRequestCount: 0,
            dateRangeLabel: null,
          })
        }
        return null
      })

    return () => {
      cancelled = true
    }
  }, [venueId])

  const handleAddInvoice = async () => {
    setAddInvoiceLoading(true)
    try {
      const createResult = await postPhoneOrders({
        ...orderToInvoice,
        venue: venueId,
      })
      currentPlan === 'Free' &&
        dispatch(updateFeatureLimit(venueId, 'PO_Numbers'))

      const createdPo = String(
        createResult?.purchaseOrderNumber ||
          orderToInvoice?.PONumber ||
          initialManualOrderPo ||
          '',
      ).trim()

      // Persist whole-order discount so GR / reconcile match create-screen total.
      await persistManualOrderWholeOrderDiscount({
        dispatch,
        venueId,
        purchaseOrderNumber: createdPo,
        discountPounds: manualOrderDiscountPounds,
      })
      setManualOrderDiscountPounds(0)

      if (pendingRematchInvoiceId) {
        const rematchInvoiceId = pendingRematchInvoiceId
        const poForReturn = createdPo
        try {
          const result = await rematchInvoiceMatching(rematchInvoiceId)
          const matchingStatus = result?.matchingStatus || null

          SuccessNotification({
            message: result?.skipped
              ? 'Manual order saved'
              : 'Manual order saved — invoice rematched',
            description: result?.skipped
              ? result?.message
              : `Invoice matching is now ${
                  matchingStatus || 'updated'
                }. Opening Invoices.`,
          })

          setPendingRematchInvoiceId(null)
          setInitialManualOrderPo('')
          setModalShow(false)
          const startDate = moment().subtract(40, 'days').format('DD/MM/YYYY')
          const endDate = moment().format('DD/MM/YYYY')
          await dispatch(fetchOrders(venueId, startDate, endDate))
          history.push(
            buildInvoicesPath(venueId, {
              q: poForReturn || undefined,
            }),
          )
          return
        } catch (error) {
          RejectedNotification({
            message: 'Manual order saved',
            description:
              error?.response?.data?.message ||
              error?.message ||
              'Could not rematch the invoice automatically — open Match on Invoices to refresh.',
          })
          setPendingRematchInvoiceId(null)
        }
      }

      setInitialManualOrderPo('')
      setModalShow(false)
      const startDate = moment().subtract(40, 'days').format('DD/MM/YYYY')
      const endDate = moment().format('DD/MM/YYYY')
      await dispatch(fetchOrders(venueId, startDate, endDate))
      SuccessNotification({
        message: 'Manual order saved',
        description: createdPo
          ? `Purchase order ${createdPo} is in Goods receipting.`
          : 'Your historical order was added. It was not sent to the supplier.',
      })
    } catch (error) {
      RejectedNotification({
        message: 'Could not save manual order',
        description:
          error?.response?.data?.message ||
          error?.message ||
          'Please check the order and try again.',
      })
    } finally {
      setAddInvoiceLoading(false)
    }
  }

  const validateOrders = () => {
    if (!orderToInvoice.products || !orderToInvoice.products.length) {
      setIsInvalidOrder(true)
    } else {
      for (let i = 0; i < orderToInvoice.products.length; i++) {
        const row = orderToInvoice.products[i] || {}
        const hasSelectedProduct = Boolean(row.product)
        const hasManualTitle = Boolean(String(row.title || '').trim())
        const quantity = Number(row.quantity)
        const unitPrice = Number(
          row.OMSPrice !== undefined && row.OMSPrice !== null
            ? row.OMSPrice
            : row.price,
        )
        const hasValidQuantity = Number.isFinite(quantity) && quantity > 0
        const hasValidUnitPrice = Number.isFinite(unitPrice) && unitPrice >= 0

        if (
          (!hasSelectedProduct && !hasManualTitle) ||
          !hasValidQuantity ||
          !hasValidUnitPrice
        ) {
          setIsInvalidOrder(true)
          break
        } else {
          setIsInvalidOrder(false)
        }
      }
    }
  }

  useEffect(() => {
    validateOrders()
  }, [JSON.stringify(orderToInvoice)])

  const array_of_obj = []
  Object.keys(orderProductsGroupedByType).forEach(typeName => {
    const dateOrders = orderProductsGroupedByType[typeName]
    array_of_obj.push(
      { product: typeName },
      {},
      {
        product: 'Product',
        quantity: 'Quantity',
        size: 'Pack size',
        price: 'Product price',
        type: 'Type',
        sku: 'Product Code',
        vatString: 'VAT',
        netString: 'Net',
        grossString: 'Gross',
        stock: 'Stock',
        value: 'Value',
        Wastage_quantity: 'Quantity of Wastage',
        Wastage_value: 'Value of Wastage',
      },
    )
    dateOrders.forEach(iterator => {
      array_of_obj.push({
        product: iterator?.product,
        quantity: iterator?.quantity,
        size: iterator?.size,
        price: iterator?.price,
        type: iterator?.type,
        sku: iterator?.sku,
        vatString: iterator?.vatString,
        netString: iterator?.netString,
        grossString: iterator?.grossString,
        stock: iterator?.stock,
        value: iterator?.value,
        Wastage_quantity: iterator?.Wastage_quantity,
        Wastage_value: iterator?.Wastage_value,
      })
    })
    array_of_obj.push({}, {})
  })

  const pathFragments = location.pathname.split('/')
  const slug = pathFragments[pathFragments.length - 1]

  useEffect(() => {
    if (slug !== 'orders' || !venueId) return undefined
    const params = new URLSearchParams(location.search)
    if (params.get('addManualOrder') !== '1') return undefined

    const rematchId = String(params.get('rematchInvoiceId') || '').trim()
    const poPrefill = String(params.get('po') || '').trim()
    if (rematchId) setPendingRematchInvoiceId(rematchId)
    if (poPrefill) setInitialManualOrderPo(poPrefill)

    setModalShow(true)

    // Drop the query so refresh/back doesn't re-open forever.
    params.delete('addManualOrder')
    params.delete('rematchInvoiceId')
    params.delete('po')
    const nextSearch = params.toString()
    const nextUrl = `${location.pathname}${nextSearch ? `?${nextSearch}` : ''}${
      location.hash || ''
    }`
    window.history.replaceState({}, '', nextUrl)
    return undefined
  }, [slug, venueId, location.pathname, location.search, location.hash])

  // CSV headers are inlined when building rows for export

  const areSomeAcceptedOrder = orders.some(order => order.supplierConfirmed)

  const invoice = useRef()
  useEffect(() => {
    if (change === 'block') {
      invoice.current.save()
      setTimeout(() => {
        setChange('none')
      }, 120)
    }
  }, [change])

  let invoiceTotal = Dinero({
    amount: 0,
    currency: 'GBP',
  })

  let totalVat = Dinero({
    amount: 0,
    currency: 'GBP',
  })

  let totalExVat = Dinero({
    amount: 0,
    currency: 'GBP',
  })
  let total_Amount = 0
  let dummy_array = ['dummy data']
  const warningMessageAddToInvoice = (
    <pre>
      You are adding an order to your account <br />
      that was placed outside of Orders Made Simple.
      <br />
      The purpose of this is to update your records and <br />
      it WILL NOT send an order to your supplier
    </pre>
  )

  const receiptingHealthTooltip = buildReceiptingHealthTooltip(
    receiptingHealth.needsAction,
    receiptingHealth.dateRangeLabel,
  )

  const invoiceMatchingWorkTooltip = buildInvoiceMatchingWorkTooltip(
    receiptingHealth.matchingWorkCount,
  )
  const creditRequestHealthTooltip = buildCreditRequestHealthTooltip(
    receiptingHealth.openCreditRequestCount,
  )

  const receiptingNavLink = (
    <Link
      to={{
        pathname: `/v/${venueId}/purchasing/receipting`,
        search: '',
      }}
      aria-label={formatPurchasingNavA11yName(
        'Goods receipting',
        receiptingHealth.needsAction,
      )}
    >
      <ReceiptingHealthTabLabel
        label='Goods receipting'
        needsActionCount={receiptingHealth.needsAction}
      />
    </Link>
  )

  const invoicesNavLink = (
    <Link
      to={{
        pathname: `/v/${venueId}/purchasing/invoices`,
        search: '',
      }}
      aria-label={formatPurchasingNavA11yName(
        'Invoices & Credit Notes',
        receiptingHealth.matchingWorkCount,
      )}
    >
      <InvoiceMatchingWorkTabLabel
        label='Invoices & Credit Notes'
        matchingWorkCount={receiptingHealth.matchingWorkCount}
      />
    </Link>
  )

  const creditRequestsNavLink = (
    <Link
      to={`/v/${venueId}/purchasing/creditnotes`}
      aria-label={formatPurchasingNavA11yName(
        'Credit Requests',
        receiptingHealth.openCreditRequestCount,
      )}
    >
      <CreditRequestHealthTabLabel
        label='Credit Requests'
        openCount={receiptingHealth.openCreditRequestCount}
      />
    </Link>
  )

  const purchasingHomePath =
    getDashboardPurchasingHomePath(venueId, userRole, customRoles) ||
    `/v/${venueId}/purchasing/invoices`

  return slug === 'purchasing' ? (
    <Redirect to={purchasingHomePath} />
  ) : (
    <Wrapper>
      <StyledMenu
        mode='horizontal'
        triggerSubMenuAction='click'
        selectedKeys={[slug === 'resolvednotes' ? 'creditnotes' : slug]}
      >
        {canSeePurchasingNav('orders') && (
          <Item key='orders'>
            <Link to={`/v/${venueId}/purchasing/orders`}>Orders</Link>
          </Item>
        )}

        {canSeePurchasingNav('receipting') && (
          <Item
            key='receipting'
            aria-label={formatPurchasingNavA11yName(
              'Goods receipting',
              receiptingHealth.needsAction,
            )}
          >
            {receiptingHealthTooltip ? (
              <Tooltip
                title={receiptingHealthTooltip}
                {...PURCHASING_NAV_TOOLTIP_PROPS}
              >
                <span
                  aria-label={formatPurchasingNavA11yName(
                    'Goods receipting',
                    receiptingHealth.needsAction,
                  )}
                >
                  {receiptingNavLink}
                </span>
              </Tooltip>
            ) : (
              receiptingNavLink
            )}
          </Item>
        )}

        {canSeePurchasingNav('invoices') && (
          <Item
            key='invoices'
            aria-label={formatPurchasingNavA11yName(
              'Invoices & Credit Notes',
              receiptingHealth.matchingWorkCount,
            )}
          >
            {invoiceMatchingWorkTooltip ? (
              <Tooltip
                title={invoiceMatchingWorkTooltip}
                {...PURCHASING_NAV_TOOLTIP_PROPS}
              >
                <span
                  aria-label={formatPurchasingNavA11yName(
                    'Invoices & Credit Notes',
                    receiptingHealth.matchingWorkCount,
                  )}
                >
                  {invoicesNavLink}
                </span>
              </Tooltip>
            ) : (
              invoicesNavLink
            )}
          </Item>
        )}

        {canSeePurchasingNav('credit-notes') && (
          <Item
            key='creditnotes'
            aria-label={formatPurchasingNavA11yName(
              'Credit Requests',
              receiptingHealth.openCreditRequestCount,
            )}
          >
            {creditRequestHealthTooltip ? (
              <Tooltip
                title={creditRequestHealthTooltip}
                {...PURCHASING_NAV_TOOLTIP_PROPS}
              >
                <span
                  aria-label={formatPurchasingNavA11yName(
                    'Credit Requests',
                    receiptingHealth.openCreditRequestCount,
                  )}
                >
                  {creditRequestsNavLink}
                </span>
              </Tooltip>
            ) : (
              creditRequestsNavLink
            )}
          </Item>
        )}

        {canSeePurchasingNav('product-issues') && (
          <Item key='product-issues'>
            <Link to={`/v/${venueId}/purchasing/product-issues`}>
              Product Issues
            </Link>
          </Item>
        )}

        {canSeePurchasingNav('gross-profit') && (
          <Item key='gross-profit'>
            <Link to={`/v/${venueId}/purchasing/gross-profit`}>
              Gross Profit
            </Link>
          </Item>
        )}

        {venue.dataplusIntegration && (
          <Item key='dataplus'>
            <Link to={`/v/${venueId}/purchasing/dataplus`}>Dataplus</Link>
          </Item>
        )}

        {canSeePurchasingNav('statement') && (
          <Item key='statement'>
            <Link to={`/v/${venueId}/purchasing/statement`}>Overview</Link>
          </Item>
        )}

        {canSeePurchasingNav('ordered-products') && (
          <Item key='ordered'>
            <Link to={`/v/${venueId}/purchasing/ordered`}>
              Ordered products
            </Link>
          </Item>
        )}

        {canSeePurchasingNav('spend-over-time') && (
          <Item key='spendTime'>
            <Link to={`/v/${venueId}/purchasing/spendTime`}>
              Spend over time
            </Link>
          </Item>
        )}
      </StyledMenu>

      <Content>
        <>
          {slug === 'gross-profit' ? null : (
            <FoodSafetyHeroBand>
              <FoodSafetyHeaderRow>
                <div>
                  <FoodSafetyPageTitle>{getTitle(slug)}</FoodSafetyPageTitle>
                  {getSubtitle(slug) ? (
                    <HeroIntro>{getSubtitle(slug)}</HeroIntro>
                  ) : null}
                </div>
                <HeaderActions>
                  <VatToggle />
                  {slug === 'orders' && !isLoading && (
                    <ManualOrderActions>
                      <Popconfirm
                        placement={'topRight'}
                        title={warningMessageAddToInvoice}
                        onConfirm={() => setModalShow(true)}
                        okText='Ok'
                        cancelText='Cancel'
                        style={{ width: '300px' }}
                      >
                        <Button type='primary'>Manually add order</Button>
                      </Popconfirm>
                      <ManualOrderNudge>
                        {CN_DOCUMENT_COPY.addOrderNudge}{' '}
                        <Link to={buildInvoicesPath(venueId)}>
                          Invoices &amp; Credit Notes
                        </Link>
                        .
                      </ManualOrderNudge>
                    </ManualOrderActions>
                  )}
                  <Modal
                    width={'72%'}
                    title={'Add order'}
                    okText={'Add manual order'}
                    visible={modalShow}
                    confirmLoading={addInvoiceLoading}
                    okButtonProps={{ disabled: isInvalidOrder }}
                    onOk={async () => {
                      await handleAddInvoice()
                    }}
                    onCancel={() => {
                      setModalShow(false)
                      setPendingRematchInvoiceId(null)
                      setInitialManualOrderPo('')
                      setManualOrderDiscountPounds(0)
                    }}
                  >
                    <p>
                      Select supplier and dates, then add products — or use{' '}
                      <strong>Build order with Ollie</strong> below to propose
                      them from an invoice/receipt. This stays a historical
                      record and does not send an order to your supplier.
                    </p>
                    <AddInvoiceModal
                      showModal={modalShow}
                      order={orderToInvoice}
                      setOrder={setOrderToInvoice}
                      suppliers={venueSupplier}
                      initialPoNumber={initialManualOrderPo}
                      onWholeOrderDiscountChange={setManualOrderDiscountPounds}
                    ></AddInvoiceModal>
                  </Modal>

                  {slug === 'ordered' && orderedProduct.length > 0 && (
                    <div>
                      <Button style={{ marginRight: '10px' }}>
                        <CSVLink
                          data={buildCsvString([
                            ...array_of_obj.map(row =>
                              Array.isArray(row)
                                ? row
                                : [
                                    row.product ?? '',
                                    row.quantity ?? '',
                                    row.size ?? '',
                                    row.price ?? '',
                                    row.type ?? '',
                                    row.sku ?? '',
                                    row.vatString ?? '',
                                    row.netString ?? '',
                                    row.grossString ?? '',
                                    row.stock ?? '',
                                    row.value ?? '',
                                    row.Wastage_quantity ?? '',
                                    row.Wastage_value ?? '',
                                  ],
                            ),
                          ])}
                          filename={`oms-products-export_${title}.csv`}
                        >
                          Download CSV
                        </CSVLink>
                      </Button>
                      <Button onClick={() => setChange('block')}>
                        <PrinterOutlined />
                      </Button>
                    </div>
                  )}
                </HeaderActions>
              </FoodSafetyHeaderRow>
            </FoodSafetyHeroBand>
          )}
          {slug === 'orders' && (
            <ThreeWayMatchEducation tab='orders' venueId={venueId} />
          )}
          {slug === 'gross-profit' && (
            <OllieContextualAsk
              fallback={OLLIE_CONTEXTUAL_ASK_FALLBACKS.gross_profit}
            />
          )}
          {OLLIE_NOTICED_SLUGS[slug] && (
            <>
              <OllieContextualAsk
                page={OLLIE_NOTICED_SLUGS[slug]}
                fallback={
                  OLLIE_CONTEXTUAL_ASK_FALLBACKS[OLLIE_NOTICED_SLUGS[slug]] ||
                  null
                }
              />
              <OllieNoticedRows page={OLLIE_NOTICED_SLUGS[slug]} />
            </>
          )}
        </>
        <StyledLayout>
          {slug === 'credit' ||
          slug === 'basket' ||
          slug === 'receipting' ||
          slug === 'creditnotes' ||
          slug === 'resolvednotes' ||
          slug === 'product-issues' ||
          slug === 'invoices' ||
          slug === 'dataplus' ||
          slug === 'gross-profit' ||
          slug === 'xero' ? (
            <OMSErrorBoundary>{children}</OMSErrorBoundary>
          ) : (
            <Fragment>
              <Filter venueId={venueId} />
              <CenteredData>
                {isLoading ? (
                  <Loading />
                ) : (slug === 'orders' && orders.length === 0 && error) ||
                  (slug !== 'orders' &&
                    slug !== 'receipting' &&
                    !areSomeAcceptedOrder &&
                    error) ? (
                  <TooMuchData />
                ) : (slug === 'orders' ||
                    slug === 'spendTime' ||
                    slug === 'ordered') &&
                  orders.length === 0 ? (
                  <NoDataScreen page={slug} />
                ) : (
                  <OMSErrorBoundary>
                    {slug === 'orders' && (
                      <OrderFinancialBreakdown
                        compact
                        orders={orders}
                        context={{ venueId }}
                        hidden={venue?.isPricesHidden}
                      />
                    )}
                    {children}
                  </OMSErrorBoundary>
                )}
              </CenteredData>
            </Fragment>
          )}
        </StyledLayout>
      </Content>
      <WrapperPdf style={{ display: change }}>
        <PDFExport ref={invoice} fileName='OMS Ordered'>
          <div className='invoice-box' ref={invoice}>
            <table cellPadding='0' cellSpacing='0'>
              <tbody>
                <tr className='top'>
                  <td colSpan='2'>
                    <table>
                      <tbody>
                        <tr>
                          <td className='title'>
                            <img src={Logo} alt='' />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>

                <tr className='information'>
                  <td colSpan='12'>
                    <table>
                      <tbody>
                        <tr>
                          <td>
                            Orders Made Simple Limited
                            <br />
                            T/A Orders Made Simple
                            <br />
                            <br />
                            84 Commercial Street
                            <br />
                            Commercial Quay
                            <br />
                            Edinburgh
                            <br />
                            EH6 6LX
                            <br /> <br />
                            SC633011
                            <br />
                            VAT Number: 347 8756 47
                          </td>

                          <td>
                            {venue.title}
                            <br />
                            {venue.addressLine1}
                            <br />
                            {venue.addressLine2}
                            <br />
                            {venue.addressCity}
                            <br />
                            {venue.addressPostCode}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>

                <tr>
                  <td colSpan='5'>&nbsp;</td>
                </tr>

                {Object.keys(allOrdersProductsGroupedByType).map(typeName => {
                  const dateOrders = allOrdersProductsGroupedByType[typeName]
                  let groupTotal = Dinero({
                    amount: 0,
                    currency: 'GBP',
                  })

                  let groupTotalVat = Dinero({
                    amount: 0,
                    currency: 'GBP',
                  })

                  let totalPrice = 0
                  dateOrders.forEach(order => {
                    const { price, hasVat, grossNumber } = order
                    totalPrice += Number(grossNumber)
                    const productPrice = Dinero({
                      amount: price && !isNaN(price) ? parseInt(price) : 0,
                      currency: 'GBP',
                    })
                    // Ordered PDF totals reflect what was originally ordered,
                    // not what was later received (short deliveries included).
                    const orderedQty = getOrderedQuantity(order)

                    const vatAmount = hasVat
                      ? productPrice.multiply(orderedQty).percentage(20)
                      : Dinero({
                          amount: 0,
                          currency: 'GBP',
                        })

                    // const lineTotal = productPrice
                    //   .multiply(updatedQuantity || quantity)
                    //   .add(vatAmount)

                    groupTotalVat = groupTotalVat.add(vatAmount)
                  })

                  groupTotal = groupTotal.add(
                    Dinero({
                      amount: !isNaN(parseInt(totalPrice))
                        ? parseInt(totalPrice)
                        : 0,
                      currency: 'GBP',
                    }),
                  )

                  return (
                    <React.Fragment key={typeName}>
                      <tr>
                        <td className='typeHeader' rowSpan='2'>
                          {typeName}
                        </td>
                        <td colSpan='11'></td>
                        <td>
                          <b>Total</b>{' '}
                          {groupTotal.multiply(100).toFormat('$0,0.00')}
                        </td>
                      </tr>
                      <tr>
                        <td colSpan='11'></td>
                        <td>
                          <b>Total VAT</b>{' '}
                          {groupTotalVat.multiply(100).toFormat('$0,0.00')}
                        </td>
                      </tr>

                      <tr className='heading'>
                        <td>Product</td>
                        <td>Qty</td>
                        <td>Size</td>
                        <td>Price</td>
                        <td>Type</td>
                        <td>SKU</td>
                        <td>VAT</td>
                        <td>Net</td>
                        <td>Gross</td>
                        <td>In Stock</td>
                        <td>value of stock</td>
                        <td>Quantity of Wastage</td>
                        <td>Value of Wastage</td>
                      </tr>

                      {dateOrders.map(order => {
                        const { price, hasVat, grossNumber } = order
                        const productPrice = Dinero({
                          amount: !isNaN(parseInt(price)) ? parseInt(price) : 0,
                          currency: 'GBP',
                        })

                        total_Amount += Number(grossNumber)
                        const orderedQty = getOrderedQuantity(order)
                        let vatAmount = hasVat
                          ? productPrice.multiply(orderedQty).percentage(20)
                          : Dinero({
                              amount: 0,
                              currency: 'GBP',
                            })

                        // let lineTotal = productPrice
                        //   .multiply(updatedQuantity || quantity)
                        //   .add(vatAmount)

                        totalVat = totalVat.add(vatAmount)

                        // invoiceTotal = invoiceTotal.add(lineTotal)

                        totalExVat = totalExVat.add(
                          productPrice.multiply(orderedQty),
                        )

                        const receivedQty = getQuantity(order)
                        const qtyCell =
                          receivedQty !== orderedQty
                            ? `${orderedQty} (received ${receivedQty})`
                            : String(orderedQty)

                        return (
                          orderedProduct && (
                            <tr key={order.key} className='item'>
                              <td>{order.product}</td>
                              <td>{qtyCell}</td>
                              <td>{order.size}</td>
                              <td>{`£${Number(price).toFixed(2) || 0}`}</td>
                              <td>{order.type}</td>
                              <td>{order.sku}</td>
                              <td>
                                {order.vatString}
                                {/* {ordervatString
                              ? `${hasVat.toFormat('$0,0.00')}`
                              : '-'} */}
                              </td>
                              <td>{order.netString}</td>
                              <td>{order.grossString}</td>
                              <td>{order.stock}</td>
                              <td>{order.value}</td>
                              <td>{order.Wastage_quantity}</td>
                              <td>{order.Wastage_value}</td>
                            </tr>
                          )
                        )
                      })}

                      <tr>
                        <td colSpan='5'>&nbsp;</td>
                      </tr>
                      <tr>
                        <td colSpan='5'>&nbsp;</td>
                      </tr>
                    </React.Fragment>
                  )
                })}
                {dummy_array.map(() => {
                  invoiceTotal = invoiceTotal.add(
                    Dinero({
                      amount: !isNaN(parseInt(total_Amount))
                        ? parseInt(total_Amount)
                        : 0,
                      currency: 'GBP',
                    }),
                  )
                })}

                <tr className='total'>
                  <td colSpan='11'></td>

                  <td>
                    {orders.some(line => line.orderFinancialSnapshot)
                      ? 'Goods excl VAT:'
                      : 'Total excl VAT:'}
                  </td>
                  <td>{totalExVat.multiply(100).toFormat('$0,0.00')}</td>
                  <td colSpan='11'></td>
                </tr>

                <tr className='total'>
                  <td colSpan='11'></td>

                  <td>
                    {orders.some(line => line.orderFinancialSnapshot)
                      ? 'Goods VAT:'
                      : 'Total VAT:'}
                  </td>
                  <td>{totalVat.multiply(100).toFormat('$0,0.00')}</td>
                  <td colSpan='11'></td>
                </tr>

                <tr className='total'>
                  <td colSpan='11'></td>

                  <td>
                    {orders.some(line => line.orderFinancialSnapshot)
                      ? 'Goods incl VAT:'
                      : 'Total:'}
                  </td>
                  <td>{invoiceTotal.multiply(100).toFormat('$0,0.00')}</td>
                  <td colSpan='11'></td>
                </tr>
              </tbody>
            </table>
            <OrderFinancialBreakdown
              orders={orders}
              context={{ venueId }}
              hidden={venue?.isPricesHidden}
            />
          </div>
        </PDFExport>
      </WrapperPdf>
    </Wrapper>
  )
}

const Wrapper = styled(FadeIn)``
const WrapperPdf = styled.div`
  .invoice-box {
    max-width: 1800px;
    margin: auto;
    padding: 30px;
    border: 1px solid ${({ theme }) => theme.colours.bgGrey};
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);
    font-size: 16px;
    line-height: 24px;
    font-family: 'Helvetica Neue', 'Helvetica', Helvetica, Arial, sans-serif;
    color: ${({ theme }) => theme.colours.oliveGrey};
  }
  .invoice-box table {
    width: 100%;
    line-height: inherit;
    text-align: left;
  }

  .invoice-box table td {
    padding: 5px;
    vertical-align: top;
  }

  .invoice-box table td.typeHeader {
    font-size: 26px;
    font-weight: bold;
  }

  .invoice-box table tr td:nth-child(2) {
    text-align: left;
  }

  .invoice-box table tr.top table td {
    padding-bottom: 20px;
  }

  .invoice-box table tr.top table td.title {
    font-size: 45px;
    line-height: 45px;
    color: ${({ theme }) => theme.colours.bbqBlack};
  }

  .invoice-box table tr.information table td {
    padding-bottom: 40px;
  }

  .invoice-box table tr.heading td {
    background: ${({ theme }) => theme.colours.mayoWhite};
    border-bottom: 1px solid ${({ theme }) => theme.colours.bgGrey};
    font-weight: bold;
  }

  .invoice-box table tr.details td {
    padding-bottom: 20px;
  }

  .invoice-box table tr.item td {
    border-bottom: 1px solid ${({ theme }) => theme.colours.mayoWhite};
  }

  .invoice-box table tr.item.last td {
    border-bottom: none;
  }

  .invoice-box table tr.total td:nth-child(2),
  .invoice-box table tr.total td:nth-child(3) {
    border-top: 2px solid ${({ theme }) => theme.colours.mayoWhite};
    font-weight: bold;
  }

  @media only screen and (max-width: 600px) {
    .invoice-box table tr.top table td {
      width: 100%;
      display: block;
      text-align: center;
    }

    .invoice-box table tr.information table td {
      width: 100%;
      display: block;
      text-align: center;
    }
  }

  /** RTL **/
  .rtl {
    direction: rtl;
    font-family: Tahoma, 'Helvetica Neue', 'Helvetica', Helvetica, Arial,
      sans-serif;
  }

  .rtl table {
    text-align: right;
  }

  .rtl table tr td:nth-child(2) {
    text-align: left;
  }
`

const Content = styled(FadeIn)`
  margin: ${({ theme }) => theme.spacing.lg} ${({ theme }) => theme.spacing.xxl};
`

const HeaderActions = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  flex-shrink: 0;
  gap: ${({ theme }) => theme.spacing.md};
`

const HeroIntro = styled.p`
  margin: 8px 0 0;
  color: #555;
  font-size: 0.95rem;
  line-height: 1.45;
`

const ManualOrderActions = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 8px;
  max-width: 360px;
`

const ManualOrderNudge = styled.p`
  margin: 0;
  text-align: right;
  font-size: 12px;
  line-height: 1.4;
  color: ${({ theme }) => theme.colours.oliveGrey || '#595959'};

  a {
    color: ${({ theme }) => theme.colours.bbqBlack || '#262626'};
    text-decoration: underline;
  }
`

const CenteredData = styled.div`
  width: 100%;
`

const StyledMenu = styled(Menu)`
  background: ${({ theme }) => theme.colours.mayoWhite};
  height: 52px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  min-width: 0;

  /* Keep natural widths so rc-menu can reliably calculate overflow. */
  > .ant-menu-item,
  > .ant-menu-submenu {
    flex: 0 0 auto;
  }

  &::before,
  &::after {
    display: none;
  }

  a:active,
  a:hover {
    color: ${({ theme }) => theme.colours.bbqBlack} !important;
    border-bottom: none !important;
  }
`

const StyledLayout = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 auto;
`

export default Orders
